// 에셋 라이브러리 접근 제어 설정
//
// 독립 /assets 라이브러리 페이지는 아래 이메일 사용자만 접근할 수 있습니다.
// (에디터/이미지 생성에 임베드되는 에셋 선택기 embedMode 는 제한 대상이 아님)
export const ASSET_ALLOWED_EMAILS = ['wizice100@gmail.com']

export function canAccessAssets(email?: string | null): boolean {
  if (!email) return false
  return ASSET_ALLOWED_EMAILS.includes(email.trim().toLowerCase())
}
